import { QueryClient } from "react-query"
import { RequestQuery } from "./types/base"
import { GetGoodsPackingsRequestQuery, GetLoadingTermsRequestQuery, GetSearchUNCodesRequestQuery, GetUnloadingTermsRequestQuery, GetUnloadingTimesRequestQuery } from "./types/order"
import { GetAddressBookListRequestQuery } from "./types/address-book"
import { ShippingPricePayload } from "./types/shipping-price"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      // refetchOnReconnect: false,
      // refetchOnMount: false,
    },
    mutations: {},
  },
})

export const queryKeys = {
  LIVE: "live",
  ISAUTH: "is_auth",
  WELCOME: "welcome",
  CONSTANTS: "constants",
  ADDRESS_LIST: (query: RequestQuery) => ["address", query],
  ADDRESS: (uuid: string | undefined) => ["address", uuid],
  ADDRESS_SEARCH: (ic: string | undefined) => ["address_search", ic],
  ADDRESS_FULLTEXT: (search: string | undefined) => ["address_fulltext", search],
  ADDRESS_USED: () => ["address_used"],
  ADDRESS_BOOK_LIST: () => ["address-book-list"],
  ADDRESS_BOOK_PAGE: (query: GetAddressBookListRequestQuery) => ["address-book-list", query],
  ADDRESS_BOOK_DETAIL: (id?: string) => ["address-book-detail", id],
  ORDER: (uuid: string | undefined) => ["order", uuid],
  ORDER_LABEL: (uuid: string | undefined) => ["order_label", uuid],
  ORDER_SUMMARY: (uuid: string | undefined) => ["order_summary", uuid],
  ORDERS: (query: RequestQuery | undefined) => ["orders", query],
  LOADING_TERMS: (query: GetLoadingTermsRequestQuery) => ["loading_terms", query],
  UNLOADING_TERMS: (query: GetUnloadingTermsRequestQuery) => ["unloading_terms", query],
  UNLOADING_TIMES: (query: GetUnloadingTimesRequestQuery) => ["unloading_times", query],
  UN_CODES_SEARCH: (query: GetSearchUNCodesRequestQuery) => ["un_codes_search", query],
  GOODS_PACKINGS: (query: GetGoodsPackingsRequestQuery) => ["goods_packings", query],
  USERS: (query: RequestQuery) => ["users", query],
  USER: (uuid: string | undefined) => ["user", uuid],
  SETTINGS: () => ["settingss"],
  ORDER_TEMPLATES: (query: RequestQuery) => ["order-templates", query],
  ORDER_TEMPLATE: (uuid: string | undefined) => ["order-template", uuid],
  SHIPPING_PRICE: (payload: ShippingPricePayload) => ["shipping-price", payload],
}
